<template>
	<div class="gradePrice-body">
		<div class="fx-header">
			<p>客户等级价格</p>
		</div>
		<div class='container'>
			<div class="left-box">
				<div class="search-box">
					<el-input
						class="search-input"
						v-model="name"
						placeholder="请输入关键词"
						size="small"
						@keyup.enter.native="treeReload">
						<el-button slot="append" icon="el-icon-search" @click="treeReload"></el-button>
					</el-input>
				</div>
				<div class="tree-box">
					<el-tree ref="tree" node-key="id" accordion :data="treeData" :default-expanded-keys="expandedKey" :highlight-current='true' class="tree" :props="defaultProps" @node-click="handleNodeClick">
						<span class="ellipsis-span" slot-scope="{ node }">
							<!-- <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start"> -->
							<span>{{ node.label }}</span>
							<!-- </el-tooltip> -->
						</span>
					</el-tree>
				</div>
			</div>
			<div class="right-box">
				<tableBox ref="tableBox"></tableBox>
			</div>
		</div>
	</div>
</template>
<script>
import tableBox from '@/components/gradePrice/tableBox.vue'
export default {
	name: 'gradePrice',
	components: {
		tableBox
	},
	data () {
		return {
			bigTypeCategory: '',
			smallTypeCategory: '',
			name: '',
			treeData: [],
			expandedKey: [],
			defaultProps: {
				children: 'sc',
				label: 'name'
			},
			bigcategoryview: null
		}
	},
	created () {
		this.checkSmallCategory()
	},
	methods: {
		// 是否对接中台
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					this.bigcategoryview = res.bigcategoryview
					this.treeReload()
				})
			})
		},
		handleNodeClick (data) {
			console.log(data)
			if (data.id === '-1') {
				this.bigTypeCategory = '0'
				this.smallTypeCategory = '0'
			} else if (data.sc) {
				this.bigTypeCategory = data.id
				this.smallTypeCategory = '0'
			} else {
				this.smallTypeCategory = data.id
				this.bigTypeCategory = '0'
			}
			this.tableBoxReload()
		},
		tableBoxReload () {
			let params = {
				keyword: this.name,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory
			}
			this.$refs.tableBox.changeData(params)
		},
		init (flag, id) {
			this.smallTypeCategory = '0'
			this.bigTypeCategory = '0'
			this.$nextTick(function () {
				this.$refs.tree.setCurrentKey('-1')
			})
			if (flag && id) {
				this.expandedKey = ['-1', id]
			} else {
				this.expandedKey = ['-1']
			}
			this.tableBoxReload()
		},
		treeReload () {
			let data = {
				name: this.name
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/category/presale/get`,
				data: data
			}).then(res => {
				if (res.result) {
					let list = res.data
					let arr = []
					let treeData = []
					if (this.bigcategoryview === 0) {
						list.forEach(item => {
							let row = {
								id: item.id,
								name: item.name,
								sc: []
							}
							arr.push(row)
						})
						treeData = arr
					} else {
						treeData = res.data
					}
					if (list.length > 0) {
						this.treeData = [{
							name: '全部',
							id: '-1',
							sc: treeData
						}]
					} else {
						this.treeData = []
					}
					let flag = this.name !== ''
					let id = list[0] ? list[0].id : null
					this.init(flag, id)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		typeChange (data) {
			this.isActive = data
			this.treeReload()
		}
	}
}
</script>
<style lang="stylus" scoped>
.gradePrice-body{
	font-family: Microsoft YaHei;
	flex: 1
	display flex
	flex-direction column
	.container{
		display: flex;
		flex: 1;
		overflow: hidden;
		padding: 20px 0 10px 0
	}
	.left-box{
		width: 200px;
		height: 100%;
		display: flex;
		flex-direction: column
	}
	.btn-box{
		width: 190px;
		height: 34px;
		border-radius: 17px;
		background-color: #F4F6F8
		display: flex
	}
	.btn{
		width: 95px;
		border-radius: 17px;
		background-color: #F4F6F8;
		display: flex;
		align-items: center;
		color: #595959;
		justify-content: center;
		cursor: pointer;
	}
	.search-box{
		margin-bottom: 10px;
		border-radius: 4px;
	}
	.tree-box{
		flex: 1
		overflow: auto
	}
	.ellipsis-span{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.active-btn{
		background-color: var(--fx-primary-color);
		color: #ffffff
	}
	.right-box{
		flex: 1;
		display: flex;
		overflow: hidden;
		margin-left: 20px
	}
}
</style>
<style lang="stylus">
.gradePrice-body {
	.is-current> .el-tree-node__content{
		background-color: #EDF6FF;
		color: var(--fx-primary-color);
	}
    .dialog-footer{
		text-align: center
	}
	.dialog-title {
		text-align: left
		.el-dialog__title {
			padding-left 10px
			border-left 5px solid var(--fx-primary-color)
		}
        .name-input{
            width :150px
        }
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
